import styled from "@emotion/styled"
import type { MarketplaceKey } from "@porsche-customer/slfinrtl-context-types"
import { allMarketplaceKeys } from "@porsche-customer/slfinrtl-context-types"
import { PFlag, PText } from "@porsche-design-system/components-react"
import type { FlagName } from "@porsche-design-system/components-react"
import { spacingStaticSm, spacingStaticXs } from "@porsche-design-system/components-react/emotion"
import { FormattedMessage } from "react-intl"
import { newsListMessages as messages } from "./newsList.messages"

const maxVisibleMarketplaces = 2

interface NewsMarketplacesProps {
	/** empty means all marketplaces */
	marketplaceKeys: MarketplaceKey[]
}

const isEveryMarketplace = (marketplaceKeys: MarketplaceKey[]) =>
	marketplaceKeys.length === 0 || allMarketplaceKeys.every((key) => marketplaceKeys.includes(key))

export const NewsMarketplaces = ({ marketplaceKeys }: NewsMarketplacesProps) => {
	if (isEveryMarketplace(marketplaceKeys)) {
		return (
			<PText color="inherit">
				<FormattedMessage {...messages.allMarketplaces} />
			</PText>
		)
	}

	const hiddenCount = marketplaceKeys.length - maxVisibleMarketplaces

	return (
		<Marketplaces>
			{marketplaceKeys.slice(0, maxVisibleMarketplaces).map((key) => (
				<Marketplace key={key}>
					<PFlag name={key as FlagName} />
					<PText color="inherit">{key}</PText>
				</Marketplace>
			))}
			{hiddenCount > 0 && <PText color="contrast-medium">+{hiddenCount}</PText>}
		</Marketplaces>
	)
}

const Marketplaces = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: ${spacingStaticSm};
`

const Marketplace = styled.span`
	display: inline-flex;
	align-items: center;
	gap: ${spacingStaticXs};
`
